import { type CreditCardBrand } from 'types';

export const formatDefaultCreditCardTitle = (
  cardCompany: CreditCardBrand,
  lastFourNumbers: string
) => {
  if (!cardCompany || !lastFourNumbers) return '';

  const brandNameByValue = {
    american_express: 'Amex',
    visa: 'Visa',
    mastercard: 'Mastercard',
    elo: 'Elo',
    diners: 'Diners',
  };

  const brandName = brandNameByValue[cardCompany] || '';

  return `${brandName}  •••• ${lastFourNumbers}`;
};
